import React from 'react';
import { Card, FTBody } from '../../Fuse';
import StackL from '../../Spacers/Spacers';
import ConsoleUL from '../../ConsoleUL/ConsoleUL';

export default function LegacyPolicyTesting() {
    return <Card title="Legacy Policies Are Applied">
        <FTBody>
            If you expected New Policies to be applied,
            this could be because you are in Step 2 of the Policies Migration and your current configurations in
            New Policies do not apply to the entered user.
        </FTBody>
        <StackL />
        <FTBody>
            During Step Two of the New Policies Migration Process, Content and Exclusion Rules
            can only match with enabled Browsing Roles added to the Console for specific users.
        </FTBody>
        <StackL />
        <FTBody><b>Possible reasons why New Policies did not apply in step 2:</b></FTBody>
        <ConsoleUL listType="numeric">
            <li>
                You did not configure a Browsing Role for the user.
            </li>
            <li>
                You do not have a matching Redirect Rule AND a matching Browsing Role for the User
                (both are required for a TAP URL Isolation redirect).
            </li>
            <li>
                If you configured an Exclusion Rule, it must match with a Browsing Role
                that references the user&apos;s email address as well as the entered URL.
            </li>
        </ConsoleUL>
        <StackL />
        <FTBody>
            {/* the ":" sign visually merges with "TIP" text w/o a style "fix" */}
            <b>TIP</b><b style={{ position: 'relative', left: 3 }}>:</b>&nbsp;
            To determine if a user is included in a Browsing Role’s User Groups, follow these steps:
        </FTBody>
        <ConsoleUL listType="numeric" style={{ marginBottom: 0 }}>
            <li>Go to the Browsing Role &gt; Assigned Users section.</li>
            <li>Click on the User Groups tab.</li>
            <li>Click on Select User Groups.</li>
            <li>Enter the user’s email in the search bar.</li>
            <li>Only User Groups that include the user’s email will display.</li>
        </ConsoleUL>
    </Card>;
}
